<template>
  <v-card style="width: 100%; height: 100%;">
    <v-tabs style="width: 100%; height: 100%;">
      <v-tab ripple active-class="activeTab" @click="designationClicked"><span>Faults Designation</span></v-tab>
      <v-tab ripple active-class="activeTab" @click="acknowledgedClicked"><span>Acknowledged Faults</span></v-tab>
      <v-tab ripple active-class="activeTab" @click="missedClicked"><span>Missed Faults</span></v-tab>
      <v-tab-item style="width: 100%; height: 100%;">
        <DetectedFaultsTable ref="faultsDesignationTable"/>
      </v-tab-item>
      <v-tab-item style="width: 100%; height: 100%;">
        <AcknowledgedFaultsTable ref="acknowledgedFaultsTable"/>
      </v-tab-item>
      <v-tab-item style="height: 100%;">
        <MissedFaultsTable  ref="missedFaultsTable"/>
      </v-tab-item>
    </v-tabs>
  </v-card>
</template>

<script>

import DetectedFaultsTable from '@/components/DetectedFaultsTable'
import MissedFaultsTable from '@/components/MissedFaultsTable'
import AcknowledgedFaultsTable from '@/components/AcknowledgedFaultsTable'

var apiService;

export default {
  name: "Faults",
  components: {
    DetectedFaultsTable,
    AcknowledgedFaultsTable,
    MissedFaultsTable
  },
  methods: {
    designationClicked (e) {
      if (! e.target.parentElement.classList.contains('activeTab')) {
        this.$refs.faultsDesignationTable.$refs.faultGroupsTable.clearPending();
        this.$refs.faultsDesignationTable.$refs.faultGroupsTable.setVesselsDataSource();
      }
    },
    acknowledgedClicked (e) {
      if (! e.target.parentElement.classList.contains('activeTab')) {
        this.$refs.acknowledgedFaultsTable.$refs.faultGroupsTable.clearPending();
        this.$refs.acknowledgedFaultsTable.$refs.faultGroupsTable.setVesselsDataSource();
      }
    },
    missedClicked (e) {
      if (! e.target.parentElement.classList.contains('activeTab')) {
        setTimeout(() => {
          this.$refs.missedFaultsTable.setTableHeight();
        }, 250)
      }
    }
  }
}

</script>

<style>
</style>